import RestClient from './rest-client'

export default class Report extends RestClient {

  static get url () {
    return this.apiUrl + '/reports'
  }
  
  static get paramKey () {
    return 'report'
  }

  static async reportLimit () {
    const { data } = await this._get(this.url + '/report_limit')
    return parseInt(data.data.val)
  }

  static async insurance (params) {
    const { data } = await this.http({
      url: this.url + '/insurance',
      method: 'POST',
      responseType: 'blob',
      params,
      headers: this.headers
    })
    return data
  }
}
